var React = require('react');

function ScrollArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("path",{"d":"M9 1.062l-4.5 4.5-4.5-4.5 1.062-1.062 3.438 3.456 3.438-3.456z","fill":"#000","opacity":".3","key":2})]);
}

ScrollArrow.defaultProps = {"width":"9","height":"6","viewBox":"0 0 9 6"};

module.exports = ScrollArrow;

ScrollArrow.default = ScrollArrow;
